// extracted by mini-css-extract-plugin
export default {"styledButton":"StyledButton_styledButton__7zZdL"};